import request from '../request';

/** 用户注册 */
export async function userRegister(params: any) {
  return request<API.CommonResponse<boolean>>({
    url: '/api/mall/rest/member/user/register/user',
    method: 'POST',
    data: params,
  });
}
